import React from "react";
import CandidateNavbar from '../Candidate/Candidate Navbar/Navbar';
import './Error_Page.css'
import  ErrorIcon from '../../assets/error-icon.svg'
import { useNavigate  } from "react-router-dom";

function ErrorPage () {
  const navigate = useNavigate();
 
    return (
      <section>
         <CandidateNavbar />
         <div className="container">
        <div className="row">
            <div className="col h-100 d-flex align-items-center justify-content-center">
                <div className="error-container text-center ">
                    <img src={ErrorIcon}   className="img-fluid" alt="" />
                    <h1 id="error-page-title">Something went wrong.</h1>
                    <p>Sorry, something went wrong there.Try later.</p>
                    <button id= "error-page-button" className="btn btn-primary"
                    onClick={()=>   navigate(-1)}
                    >Retry</button>
                </div>
            </div>
        </div>

      </div>
      </section>
     
    )
}
export default ErrorPage;